export const TokenEx = window.TokenEx;
